import {scan} from 'rxjs/operators';
import {LoginActionType} from './login-action';

export const loginReducer = () =>
  scan<any>((state, action) => {
    return action;

  }, {});
